export const fetchCurrencyRates = async () => {
  try {
    const response = await fetch('https://api.exchangerate.host/latest?base=EUR');
    
    if (!response.ok) {
      throw new Error('Fehler beim Abrufen der Währungskurse');
    }
    
    const data = await response.json();
    
    if (data.success && data.rates) {
      return data.rates;
    } else {
      throw new Error('Ungültiges Antwortformat');
    }
  } catch (error) {
    console.error('Währungs-API-Fehler:', error);
    
    // Fallback to a backup API
    try {
      const fallbackResponse = await fetch('https://api.frankfurter.app/latest?from=EUR');
      const fallbackData = await fallbackResponse.json();
      
      if (fallbackData.rates) {
        return fallbackData.rates;
      }
    } catch (fallbackError) {
      console.error('Fallback-API-Fehler:', fallbackError);
    }
    
    // Return mock rates if all APIs fail
    return {
      USD: 1.08,
      GBP: 0.86,
      JPY: 162.5,
      AUD: 1.65,
      CAD: 1.51,
      CHF: 0.94,
      CNY: 7.85,
      SEK: 11.8,
      NOK: 11.9,
      INR: 90.2,
      RUB: 100.5
    };
  }
};